/**
 * Hook pour les mouvements financiers
 * Récupère les détails des entrées/sorties pour une date donnée
 */

import { useQuery } from '@tanstack/react-query';
import { movementsApi, type MovementsQueryParams } from '@/services/api';

// ========================================
// Query Keys
// ========================================

export const movementKeys = {
    all: ['movements'] as const,
    date: (date: string) => [...movementKeys.all, 'date', date] as const,
    range: (startDate: string, endDate: string) =>
        [...movementKeys.all, 'range', startDate, endDate] as const,
};

// ========================================
// Hooks
// ========================================

/**
 * Récupère les mouvements pour une date spécifique
 * Ne s'exécute que quand date est défini
 */
export function useMovementsByDate(date: string | null) {
    return useQuery({
        queryKey: movementKeys.date(date ?? ''),
        queryFn: () => movementsApi.getByDate(date!),
        enabled: !!date,
        staleTime: 60_000, // 1 minute
    });
}

/**
 * Récupère les mouvements pour une plage de dates
 */
export function useMovementsRange(params: MovementsQueryParams | null) {
    return useQuery({
        queryKey: params?.startDate && params?.endDate
            ? movementKeys.range(params.startDate, params.endDate)
            : movementKeys.all,
        queryFn: () => movementsApi.get(params!),
        enabled: !!(params?.startDate && params?.endDate),
        staleTime: 60_000,
    });
}
